export default () => {
  let scrollBarWidth =
    window.innerWidth - document.documentElement.clientWidth

  if (scrollBarWidth % 2 !== 0) {
    scrollBarWidth += 1
  }

  document.body.style.setProperty('--scrollBarWidth', `${scrollBarWidth}px`)
}
